import { Stack, Typography } from "@mui/material";
import { AcornIcon, PhoneIcon } from "assets";
import { LinkButton } from "components";
import React from "react";

export const AdditionalInformation = () => {
  const config = [
    {
      icon: <AcornIcon width={40} height={40} />,
      title: "Atsidaryti sąskaitą „Swedbank“",
      subtitle: "Atidarykite verslo sąskaitą internetu, neišeidami iš namų",
      linkText: "Atidaryti sąskaitą nuotoliniu būdu",
      link: "https://www.swedbank.lt/business/d2d/accounts/openNewAccount",
    },
    {
      icon: <PhoneIcon width={40} height={40} />,
      title: "Pasikonsultuokite su „Swedbank“",
      subtitle: "Pasitarkite dėl Jūsų įmonės finansinės sveikatos. Užsiregistruokite nemokamai konsultacijai",
      linkText: "Sužinokite daugiau",
      link: "https://www.swedbank.lt/business/useful/more/appointments",
    },
  ];
  return (
    <>
      <Typography variant="h3" color="primary" mb="1rem" textAlign={{ xs: "center", md: "left" }}>
        Jus taip pat gali dominti
      </Typography>
      <Stack direction={{ sm: "column", md: "row" }} justifyContent="space-between" spacing={4}>
        {config.map(({ icon, title, subtitle, linkText, link }) => (
          <Stack
            key={title}
            justifyContent="space-between"
            alignItems="center"
            backgroundColor="background4.main"
            textAlign="center"
            pt="1rem"
            pb="2rem"
            spacing={2}
            width="100%"
            mt={{ xs: "1rem" }}
          >
            {icon}
            <Typography variant="h4">{title}</Typography>
            <Typography variant="body2" fontWeight={400}>
              {subtitle}
            </Typography>
            <LinkButton href={link}>{linkText}</LinkButton>
          </Stack>
        ))}
      </Stack>
    </>
  );
};
